import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 84px;
  right: 94px;
  z-index: 999;

  opacity: 0;
  transform: translateX(400px);
  pointer-events: none;
  transition: all 0.7s ease;

  &.show {
    opacity: 1;
    transform: translateX(0);
    pointer-events: all;
  }

  .floating-card {
    width: 458px;
    height: 100%;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.25rem;
    padding: 20px;
    box-shadow: 0 20px 40px rgba(16, 24, 40, 0.12);
    position: relative;
  }

  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #6b7280;
  }

  .close-btn:hover {
    color: #111827;
  }

  .floating-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
  }

  .floating-icon {
    width: 40px;
    height: 40px;
    border-radius: 0.25rem;
    background: linear-gradient(90deg, #007bff 0%, #009f79 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .floating-header h4 {
    font-size: 16px;
    font-weight: 700;
    margin: 0;
  }

  .floating-badge {
    display: inline-block;
    color: rgba(54, 103, 147, 1);
    border: 1.5px solid var(--Brand-Blue-600, rgba(54, 103, 147, 1));
    border-radius: 4px;
    margin-bottom: 16px;
  }

  .ai-title {
    font-size: 24px;
    font-weight: 500;
    color: #0f172a;
    margin: 0;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
      Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }

  .ai-subtitle {
    font-size: 13px;
  }

  .floating-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .floating-description {
    font-size: 13px;
    color: #6b7280;
    margin-bottom: 12px;

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .floating-date {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 8px;
  }

  .floating-link {
    font-size: 16px;
    font-weight: 600;

    background: linear-gradient(90deg, #007bff, #009f79);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    color: transparent;

    border: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    padding: 0;
    text-decoration: none;
  }

  @media (max-width: 768px) {
    right: 16px;
    left: 16px;
    bottom: 16px;

    .floating-card {
      width: 100%;
    }
  }
`;
